import { FC, useState } from 'react';
import {
  Alert,
  Badge,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardText,
  CardTitle,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  FormText,
  InputGroup,
  InputGroupText,
  Nav,
  NavItem,
  NavLink,
  Breadcrumb,
  BreadcrumbItem,
  Pagination,
  PaginationItem,
  PaginationLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Table,
  ListGroup,
  ListGroupItem,
  Progress,
  Spinner,
  Collapse,
  UncontrolledCollapse,
  PopoverBody,
  PopoverHeader,
  UncontrolledTooltip,
  UncontrolledPopover,
  UncontrolledDropdown,
  UncontrolledButtonDropdown,
} from 'reactstrap';
import classnames from 'classnames';

import { ShowcaseItem } from '@routes/theme-showcase/components/ShowcaseSection';

export const ReactstrapShowcase: FC = () => {
  const [activeTab, setActiveTab] = useState('1');
  const [modalOpen, setModalOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);
  const [collapseOpen, setCollapseOpen] = useState(false);

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <>
      <ShowcaseItem title='Alerts & Badges'>
        <Alert color='primary' className='w-100'>
          Primary Alert
        </Alert>
        <Alert color='secondary' className='w-100'>
          Secondary Alert
        </Alert>
        <Alert color='success' className='w-100'>
          Success Alert
        </Alert>
        <Alert color='danger' className='w-100'>
          Danger Alert
        </Alert>
        <Alert color='warning' className='w-100'>
          Warning Alert
        </Alert>
        <Alert color='info' className='w-100'>
          Info Alert
        </Alert>
        <Badge color='primary'>Primary</Badge>
        <Badge color='secondary'>Secondary</Badge>
        <Badge color='success'>Success</Badge>
        <Badge color='danger'>Danger</Badge>
        <Badge color='warning'>Warning</Badge>
        <Badge color='info'>Info</Badge>
        <Badge color='light'>Light</Badge>
        <Badge color='dark'>Dark</Badge>
        <h6 className='text-ThemeTextLight mt-3 w-100'>Outline Badges</h6>
        <Badge color='primary' className='outline'>Primary</Badge>
        <Badge color='secondary' className='outline'>Secondary</Badge>
        <Badge color='success' className='outline'>Success</Badge>
        <Badge color='danger' className='outline'>Danger</Badge>
        <Badge color='warning' className='outline'>Warning</Badge>
      </ShowcaseItem>

      <ShowcaseItem title='Buttons'>
        <div className='d-flex flex-column gap-2'>
          <div className='d-flex align-items-center flex-wrap gap-2'>
            <Button color='primary'>Primary</Button>
            <Button color='secondary'>Secondary</Button>
            <Button color='success'>Success</Button>
            <Button color='info'>Info</Button>
            <Button color='warning'>Warning</Button>
            <Button color='danger'>Danger</Button>
            <Button color='link'>Link</Button>
          </div>
          <h6 className='text-ThemeTextLight mt-3'>Outline Buttons</h6>
          <div className='d-flex align-items-center flex-wrap gap-2'>
            <Button outline color='primary'>
              Primary
            </Button>
            <Button outline color='secondary'>
              Secondary
            </Button>
            <Button outline color='success'>
              Success
            </Button>
            <Button outline color='info'>
              Info
            </Button>
            <Button outline color='warning'>
              Warning
            </Button>
            <Button outline color='danger'>
              Danger
            </Button>
            <Button outline color='light'>
              Light
            </Button>
            <Button outline color='dark'>
              Dark
            </Button>
          </div>
          <h6 className='text-ThemeTextLight mt-3'>Button Group</h6>
          <ButtonGroup>
            <Button>Left</Button>
            <Button>Middle</Button>
            <Button>Right</Button>
          </ButtonGroup>
        </div>
      </ShowcaseItem>

      <ShowcaseItem title='Cards'>
        <Row className='w-100 m-0'>
          <Col sm='6' className='mb-3 mb-sm-0 pl-0'>
            <Card>
              <CardHeader>Card Header</CardHeader>
              <CardBody>
                <CardTitle>Card Title</CardTitle>
                <CardText>
                  Some quick example text to build on the card title and make up the bulk of the card's content.
                </CardText>
                <Button>Go somewhere</Button>
              </CardBody>
              <CardFooter>Card Footer</CardFooter>
            </Card>
          </Col>
          <Col sm='6' className='pr-0'>
            <Card>
              <CardHeader>Featured</CardHeader>
              <CardBody>
                <CardTitle>Special Title Treatment</CardTitle>
                <CardText>With supporting text below as a natural lead-in to additional content.</CardText>
                <Button>Go somewhere</Button>
              </CardBody>
              <CardFooter>2 days ago</CardFooter>
            </Card>
          </Col>
        </Row>
      </ShowcaseItem>

      <ShowcaseItem title='Forms'>
        <Form className='w-100'>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for='exampleEmail'>Email</Label>
                <Input type='email' name='email' id='exampleEmail' placeholder='with a placeholder' />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for='examplePassword'>Password</Label>
                <Input type='password' name='password' id='examplePassword' placeholder='password placeholder' />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label for='exampleAddress'>Address</Label>
            <Input type='text' name='address' id='exampleAddress' placeholder='1234 Main St' />
          </FormGroup>
          <FormGroup>
            <Label for='exampleSelect'>Select</Label>
            <Input type='select' name='select' id='exampleSelect'>
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Checkboxes</Label>
            <FormGroup check>
              <Label check>
                <Input type='checkbox' /> Check me out
              </Label>
            </FormGroup>
          </FormGroup>
          <FormGroup>
            <Label for='exampleText'>Text Area</Label>
            <Input type='textarea' name='text' id='exampleText' />
          </FormGroup>
          <InputGroup>
            <InputGroupText>@</InputGroupText>
            <Input placeholder='username' />
          </InputGroup>
          <FormGroup className='mt-3'>
            <Label for='exampleUrl'>Valid Input</Label>
            <Input valid placeholder='Valid input...' />
            <FormFeedback valid>Sweet! that name is available</FormFeedback>
            <FormText>Example help text that remains unchanged.</FormText>
          </FormGroup>
          <FormGroup>
            <Label for='examplePassword'>Invalid Input</Label>
            <Input invalid placeholder='Invalid input...' />
            <FormFeedback>Oh noes! that name is already taken</FormFeedback>
          </FormGroup>
        </Form>
      </ShowcaseItem>

      <ShowcaseItem title='Navigation'>
        <Nav tabs className='w-100'>
          <NavItem>
            <NavLink href='#' active>
              Link
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href='#'>Link</NavLink>
          </NavItem>
          <NavItem>
            <NavLink disabled href='#'>
              Disabled
            </NavLink>
          </NavItem>
        </Nav>
        <Breadcrumb className='w-100'>
          <BreadcrumbItem>
            <a href='#'>Home</a>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <a href='#'>Library</a>
          </BreadcrumbItem>
          <BreadcrumbItem active>Data</BreadcrumbItem>
        </Breadcrumb>
        <Pagination aria-label='Page navigation example' className='w-100'>
          <PaginationItem>
            <PaginationLink first href='#' />
          </PaginationItem>
          <PaginationItem>
            <PaginationLink previous href='#' />
          </PaginationItem>
          <PaginationItem>
            <PaginationLink href='#'>1</PaginationLink>
          </PaginationItem>
          <PaginationItem>
            <PaginationLink href='#'>2</PaginationLink>
          </PaginationItem>
          <PaginationItem>
            <PaginationLink href='#'>3</PaginationLink>
          </PaginationItem>
          <PaginationItem>
            <PaginationLink next href='#' />
          </PaginationItem>
          <PaginationItem>
            <PaginationLink last href='#' />
          </PaginationItem>
        </Pagination>
      </ShowcaseItem>

      <ShowcaseItem title='Tabs'>
        <Nav tabs className='w-100'>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '1' })}
              onClick={() => {
                toggleTab('1');
              }}
              style={{ cursor: 'pointer' }}
            >
              Tab 1
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '2' })}
              onClick={() => {
                toggleTab('2');
              }}
              style={{ cursor: 'pointer' }}
            >
              Tab 2
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab} className='p-3 border border-top-0 w-100'>
          <TabPane tabId='1'>
            <Row>
              <Col sm='12'>
                <h4>Tab 1 Contents</h4>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId='2'>
            <Row>
              <Col sm='6'>
                <Card body>
                  <CardTitle>Special Title Treatment</CardTitle>
                  <CardText>With supporting text below as a natural lead-in to additional content.</CardText>
                  <Button>Go somewhere</Button>
                </Card>
              </Col>
              <Col sm='6'>
                <Card body>
                  <CardTitle>Special Title Treatment</CardTitle>
                  <CardText>With supporting text below as a natural lead-in to additional content.</CardText>
                  <Button>Go somewhere</Button>
                </Card>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </ShowcaseItem>

      <ShowcaseItem title='Modals'>
        <Button onClick={() => setModalOpen(!modalOpen)}>{modalOpen ? 'Close Modal' : 'Open Modal'}</Button>
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} backdrop='static' scrollable>
          <ModalHeader toggle={() => setModalOpen(!modalOpen)}>Modal title</ModalHeader>
          <ModalBody>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
            ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat
            nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit
            anim id est laborum.
          </ModalBody>
          <ModalFooter>
            <Button color='link-secondary' onClick={() => setModalOpen(!modalOpen)}>
              Cancel
            </Button>
            <Button color='primary' onClick={() => setModalOpen(!modalOpen)}>
              Do Something
            </Button>
          </ModalFooter>
        </Modal>
      </ShowcaseItem>

      <ShowcaseItem title='Dropdowns'>
        <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen((prevState) => !prevState)}>
          <DropdownToggle caret>Dropdown</DropdownToggle>
          <DropdownMenu>
            <DropdownItem header>Header</DropdownItem>
            <DropdownItem>
              <i className='fal fa-user me-2' />
              Some Action
            </DropdownItem>
            <DropdownItem text>Dropdown Item Text</DropdownItem>
            <DropdownItem disabled>
              <i className='fal fa-ban me-2' />
              Action (disabled)
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem>
              <i className='fal fa-edit me-2' />
              Foo Action
            </DropdownItem>
            <DropdownItem>
              <i className='fal fa-trash me-2' />
              Bar Action
            </DropdownItem>
            <DropdownItem>
              <i className='fal fa-save me-2' />
              Quo Action
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>

        <UncontrolledDropdown>
          <DropdownToggle caret>Uncontrolled Dropdown</DropdownToggle>
          <DropdownMenu>
            <DropdownItem header>Header</DropdownItem>
            <DropdownItem>Action 1</DropdownItem>
            <DropdownItem>Action 2</DropdownItem>
            <DropdownItem divider />
            <DropdownItem>Another Action</DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>

        <UncontrolledButtonDropdown>
          <DropdownToggle caret>
            <i className='fal fa-bars' />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem>Action</DropdownItem>
            <DropdownItem>Another Action</DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      </ShowcaseItem>

      <ShowcaseItem title='Offcanvas'>
        <Button color='primary' onClick={() => setOffcanvasOpen(!offcanvasOpen)}>
          Open Offcanvas
        </Button>
        <Offcanvas isOpen={offcanvasOpen} toggle={() => setOffcanvasOpen(!offcanvasOpen)}>
          <OffcanvasHeader toggle={() => setOffcanvasOpen(!offcanvasOpen)}>Offcanvas</OffcanvasHeader>
          <OffcanvasBody>
            <strong>This is the Offcanvas body.</strong>
          </OffcanvasBody>
        </Offcanvas>
      </ShowcaseItem>

      <ShowcaseItem title='Table'>
        <Table className='w-100'>
          <thead>
            <tr>
              <th>#</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Username</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope='row'>1</th>
              <td>Mark</td>
              <td>Otto</td>
              <td>@mdo</td>
            </tr>
            <tr>
              <th scope='row'>2</th>
              <td>Jacob</td>
              <td>Thornton</td>
              <td>@fat</td>
            </tr>
            <tr>
              <th scope='row'>3</th>
              <td>Larry</td>
              <td>the Bird</td>
              <td>@twitter</td>
            </tr>
          </tbody>
        </Table>
      </ShowcaseItem>

      <ShowcaseItem title='List Group'>
        <ListGroup className='w-100'>
          <ListGroupItem>Cras justo odio</ListGroupItem>
          <ListGroupItem>Dapibus ac facilisis in</ListGroupItem>
          <ListGroupItem>Morbi leo risus</ListGroupItem>
          <ListGroupItem>Porta ac consectetur ac</ListGroupItem>
          <ListGroupItem>Vestibulum at eros</ListGroupItem>
        </ListGroup>
      </ShowcaseItem>

      <ShowcaseItem title='Progress'>
        <Progress value={50} className='w-100' />
        <Progress multi className='w-100'>
          <Progress bar value='15'>
            Meh
          </Progress>
          <Progress bar color='success' value='30'>
            Wow!
          </Progress>
          <Progress bar color='info' value='25'>
            Cool
          </Progress>
          <Progress bar color='warning' value='20'>
            Caution
          </Progress>
          <Progress bar color='danger' value='5'>
            !!
          </Progress>
        </Progress>
      </ShowcaseItem>

      <ShowcaseItem title='Spinners'>
        <Spinner color='primary' />
        <Spinner color='secondary' />
        <Spinner color='success' />
        <Spinner color='danger' />
        <Spinner color='warning' />
        <Spinner color='info' />
        <Spinner color='light' />
        <Spinner color='dark' />
      </ShowcaseItem>

      <ShowcaseItem title='Collapse'>
        <div className='w-100 mb-2'>
          <Button color='primary' onClick={() => setCollapseOpen(!collapseOpen)} style={{ marginBottom: '1rem' }}>
            Toggle Manual Collapse
          </Button>
          <Collapse isOpen={collapseOpen}>
            <Card>
              <CardBody>
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil
                anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.
              </CardBody>
            </Card>
          </Collapse>
        </div>

        <div className='w-100'>
          <Button color='primary' id='toggler' style={{ marginBottom: '1rem' }}>
            Toggle Uncontrolled Collapse
          </Button>
          <UncontrolledCollapse toggler='#toggler'>
            <Card>
              <CardBody>
                Uncontrolled collapse content managed by toggler ID. This handles its own state without React rendering
                updates.
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
      </ShowcaseItem>

      <ShowcaseItem title='Overlays'>
        <div>
          <span style={{ textDecoration: 'underline', color: 'blue', cursor: 'help' }} id='UncontrolledTooltipExample'>
            Hover for Tooltip
          </span>
          <UncontrolledTooltip placement='top' target='UncontrolledTooltipExample'>
            Hello world! I am a tooltip.
          </UncontrolledTooltip>
        </div>

        <div>
          <Button id='UncontrolledPopover' type='button' color='info' outline>
            Click for Popover
          </Button>
          <UncontrolledPopover placement='bottom' target='UncontrolledPopover' trigger='focus'>
            <PopoverHeader>Popover Title</PopoverHeader>
            <PopoverBody>
              Sed posuere consectetur est at lobortis. Aenean eu leo quam. Pellentesque ornare sem lacinia quam
              venenatis vestibulum.
            </PopoverBody>
          </UncontrolledPopover>
        </div>
      </ShowcaseItem>
    </>
  );
};
